import { useAuth } from '../context/AuthContext';

interface SidebarProps {
  activeView: string;
  onNavigate: (view: string) => void;
}

const navItems = [
  { section: 'Operação' },
  { id: 'dashboard', label: 'Painel', icon: '📊' },
  { id: 'sdr-monitoring', label: 'Métricas do SDR', icon: '📈' },
  { id: 'inbox', label: 'Atendimento', icon: '💬' },
  { id: 'tickets', label: 'Tickets', icon: '🎫' },
  { section: 'Administração' },
  { id: 'users', label: 'Usuários', icon: '👥' },
  { id: 'departments', label: 'Deptos & Filas', icon: '🏢' },
  { id: 'customers', label: 'Clientes', icon: '👤' },
  { id: 'companies', label: 'Empresas', icon: '🏢' },
  { id: 'templates', label: 'Templates', icon: '📝' },
  { id: 'rules', label: 'Regras', icon: '🔀' },
  { section: 'SGP' },
  { id: 'sgp', label: 'Dashboard SGP', icon: '🔌' },
  { id: 'sgp-auth', label: 'Autorizações', icon: '🔐' },
  { section: 'Configuração' },
  { id: 'ai-intelligence', label: 'Inteligência da IA', icon: '🧠' },
  { id: 'agents', label: 'Agentes', icon: '◉' },
  { id: 'settings', label: 'Integrações', icon: '⚙️' },
];

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

function getStatusColor(role: string): string {
  const colors: Record<string, string> = {
    SUPER_ADMIN: '#f57c00',
    COMPANY_ADMIN: '#1565c0',
    AGENT: '#2e7d32',
  };
  return colors[role] || '#546e7a';
}

function roleLabel(role: string): string {
  const labels: Record<string, string> = {
    SUPER_ADMIN: 'Super admin',
    COMPANY_ADMIN: 'Administrador',
    AGENT: 'Atendente',
  };
  return labels[role] || role;
}

export function Sidebar({ activeView, onNavigate }: SidebarProps) {
  const { user, logout } = useAuth();

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand-mark">MG</div>
        <div className="sidebar-brand-text">
          <strong>MGBotISP</strong>
          <span>Atendimento profissional</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item, i) => {
          if ('section' in item) {
            return <div key={item.section} className="nav-section">{item.section}</div>;
          }
          if ('id' in item) {
            return (
              <button
                key={item.id}
                className={`nav-item${activeView === item.id ? ' active' : ''}`}
                onClick={() => onNavigate(item.id)}
                type="button"
              >
                <span className="icon">{item.icon}</span>
                {item.label}
              </button>
            );
          }
          return null;
        })}
      </nav>

      <div className="sidebar-footer">
        <div
          className="avatar"
          style={{ background: user ? getStatusColor(user.role) : '#546e7a' }}
        >
          {user?.name ? getInitials(user.name) : '?'}
        </div>
        <div className="info">
          <strong>{user?.name || 'Visitante'}</strong>
          <span>{user ? roleLabel(user.role) : 'Desconectado'}</span>
        </div>
        <button
          className="ghost"
          onClick={logout}
          title="Sair"
          style={{ color: '#90a4ae', padding: '4px 8px', fontSize: '1.1rem' }}
          type="button"
        >
          ⏻
        </button>
      </div>
    </aside>
  );
}
